import { render } from "./StripedTable.vue?vue&type=template&id=8c08968c"
import script from "./StripedTable.vue?vue&type=script&lang=js"
export * from "./StripedTable.vue?vue&type=script&lang=js"
script.render = render

export default script